import React from 'react';
import { loginRequest } from "../authConfig";
import { MsalContext, IMsalContext } from "@azure/msal-react";
import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, SplitButton } from '@fluentui/react-components'
import type { MenuButtonProps } from "@fluentui/react-components";

export interface SignOutButtonProps
{
}

export interface SignOutButtonState
{
}

export class SignOutButton extends React.Component<SignOutButtonProps, SignOutButtonState>
{
    context!: IMsalContext;
    static contextType = MsalContext;

    doSignOut(type: string)
    {
        if (type === "popup")
            this.context.instance.logoutPopup({ mainWindowRedirectUri: "/" });
        else if (type === "redirect")
            this.context.instance.logoutRedirect();
    }

    render()
    {
        const primaryActionButtonProps = { onClick: () => this.doSignOut("popup") };

        const menuTrigger = (triggerProps: MenuButtonProps) => (
            <SplitButton menuButton={triggerProps} primaryActionButton={primaryActionButtonProps}>
                Sign out</SplitButton>);

        return (
            <>
                <Menu positioning="below-end">
                    <MenuTrigger disableButtonEnhancement>
                        {menuTrigger}
                    </MenuTrigger>
                    <MenuPopover>
                        <MenuList>
                            <MenuItem onClick={() => this.doSignOut("popup")}>Popup</MenuItem>
                            <MenuItem onClick={() => this.doSignOut("redirect")}>Redirect</MenuItem>
                        </MenuList>
                    </MenuPopover>
                </Menu>
            </>
        );
    }
}